import { Box, Checkbox, CheckboxGroup, Flex } from '@chakra-ui/react'
import React from 'react'

import FormContentBlock from '../FormContentBlock'
import { FormContext, type FormInputType } from '../types'

const FormInputMultiCheckbox: React.FC<{
  input: FormInputType & { type: 'multi-checkbox' }
}> = ({ input }) => {
  const { name: inputName, onChange: inputOnChange } = input
  const { submitting, direction, onChange } = React.useContext(FormContext)
  const handleChange = React.useCallback(
    (values: string[]) => {
      onChange(inputName, values)
      inputOnChange?.(values)
    },
    [inputName, inputOnChange, onChange]
  )
  const directionToUse = input.direction ?? direction

  return (
    <Flex direction={['column', directionToUse === 'horizontal' ? 'row' : 'column']}>
      <CheckboxGroup
        onChange={handleChange}
        defaultValue={input.initialValue ?? []}
        isDisabled={submitting || input.disabled}
      >
        {input.options.map(item => (
          <Checkbox key={item.value} value={item.value} my="4px" isDisabled={item.disabled}>
            <Box mt="-3px">
              <FormContentBlock content={item.label} />
            </Box>
          </Checkbox>
        ))}
      </CheckboxGroup>
    </Flex>
  )
}

export default FormInputMultiCheckbox
